module.exports = __webpack_public_path__ + "static/media/survey.8ac8f1cc.png";